import Box from "@mui/material/Box";
import Profile from "./Profile";

// ==============================|| HEADER - CONTENT ||============================== //

export default function HeaderContent() {
    return (
        <>
            <Box sx={{width: "100%", ml: 1}}/>
            <Profile/>
        </>
    );
}
